// // import React, { useState, useEffect } from "react";
// // import { motion, AnimatePresence } from "framer-motion";
// // import { Footer } from "../navbar/Footer";
// // import axios from "axios";
// // import "./Ecommerce.css";
// // import { Link } from "react-router-dom";
// // const Productcategory = () => {
// //   const [categories, setCategories] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   // Sample banner images - replace with your actual banner images
// //   const bannerImages = [
// //     "assets/img/Bannerimages/Contact.jpg",
// //     "assets/img/sub-hero-banner.jpg",
// //     "assets/img/Bannerimages/Contact.jpg",
// //     "assets/img/Bannerimages/banner4.jpg",
// //     "assets/img/Bannerimages/banner5.jpg",
// //   ];

// //   useEffect(() => {
// //     const fetchCategories = async () => {
// //       try {
// //         const response = await axios.get(
// //           "https://vogelkoparchitects.com/api/api/mcategories/"
// //         );
// //         setCategories(response.data);
// //         setLoading(false);
// //       } catch (err) {
// //         setError(err.message);
// //         setLoading(false);
// //       }
// //     };
// //     fetchCategories();
// //   }, []);

// //   if (loading) {
// //     return (
// //       <div className="ecommerce-loading-container">
// //         <div className="ecommerce-spinner"></div>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return <div className="ecommerce-error-message">Error: {error}</div>;
// //   }

// //   return (
// //     <div className="ecommerce-section">
// //       {/* Auto-moving banner */}
// //       <div className="ecommerce-banner-container">
// //         <div className="ecommerce-banner-slider">
// //           {bannerImages.map((image, index) => (
// //             <div
// //               key={index}
// //               className="ecommerce-banner-slide"
// //               style={{ backgroundImage: `url(${image})` }}
// //             >
// //               <div className="ecommerce-banner-overlay">
// //                 <div className="ecommerce-banner-content">
// //                   <h1 className="ecommerce-banner-title">PRODUCT</h1>
// //                   <p className="ecommerce-banner-subtitle">
// //                     Discover Our Premium Collections
// //                   </p>
// //                 </div>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       <div className="ecommerce-container">
// //         <div className="ecommerce-grid">
// //           {categories.map((category) => (
// //             <motion.div
// //               key={category.id}
// //               className="ecommerce-card"
// //               initial={{ opacity: 0, y: 20 }}
// //               animate={{ opacity: 1, y: 0 }}
// //               transition={{ duration: 0.5 }}
// //             >
// //               <Link to={`/productsubcategory/${category.id}`}>
// //                 <div className="ecommerce-img-container">
// //                   <img
// //                     src={category.image}
// //                     className="ecommerce-img"
// //                     alt={category.name}
// //                   />
// //                   <div className="ecommerce-img-overlay"></div>
// //                 </div>
// //                 <div className="ecommerce-card-body">
// //                   <h5 className="ecommerce-card-title">{category.name}</h5>
// //                   <div className="ecommerce-subcategories">
// //                     <h6 className="ecommerce-subcategories-title">
// //                       Subcategories
// //                     </h6>
// //                     <ul className="ecommerce-subcategories-list">
// //                       {category.subcategory_name.map((subcategory, index) => (
// //                         <li key={index} className="ecommerce-subcategory-item">
// //                           {subcategory}
// //                         </li>
// //                       ))}
// //                     </ul>
// //                   </div>
// //                 </div>
// //               </Link>
// //             </motion.div>
// //           ))}
// //         </div>
// //       </div>
// //       <Footer />
// //     </div>
// //   );
// // };

// // export default Productcategory;

// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { Footer } from "../navbar/Footer";
// import axios from "axios";
// import "./Ecommerce.css";
// import { Link } from "react-router-dom";

// const Productcategory = () => {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentSlide, setCurrentSlide] = useState(0);

//   // Banner images - replace with your actual images
//   const bannerImages = [
//     "assets/img/Bannerimages/banner1.jpg",
//     "assets/img/Bannerimages/banner2.jpg",
//     "assets/img/Bannerimages/banner3.jpg",
//   ];

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const response = await axios.get(
//           "https://vogelkoparchitects.com/api/api/mcategories/"
//         );
//         setCategories(response.data);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };
//     fetchCategories();

//     // Auto-rotate banner
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % bannerImages.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return <div className="error-message">Error: {error}</div>;
//   }

//   return (
//     <>
//       <div className="banner-container">
//         <div
//           className="banner-slider"
//           style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//         >
//           {bannerImages.map((image, index) => (
//             <div
//               key={index}
//               className="banner-slide"
//               style={{ backgroundImage: `url(${image})` }}
//             >
//               <div className="banner-overlay">
//                 <h1>PRODUCT</h1>
//               </div>
//             </div>
//           ))}
//         </div>
//         <div className="banner-dots">
//           {bannerImages.map((_, index) => (
//             <button
//               key={index}
//               className={`dot ${index === currentSlide ? "active" : ""}`}
//               onClick={() => setCurrentSlide(index)}
//             />
//           ))}
//         </div>
//       </div>
//       {/* <div className="product-page"> */}
//       {/* Banner Carousel */}

//       {/* </div> */}
//       <Footer />
//     </>
//   );
// };

// export default Productcategory;
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Footer } from "../navbar/Footer";
import axios from "axios";
import "./Ecommerce.css";
import { Link } from "react-router-dom";

const Productcategory = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Banner images - replace with your actual images
  const bannerImages = [
    "/assets/img/ecommerce/banner/banner1.jpg",
    "/assets/img/ecommerce/banner/banner1.jpg",
    "/assets/img/ecommerce/banner/banner1.jpg",
  ];

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://vogelkoparchitects.com/api/ecom/categories/",
        );
        setCategories(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchCategories();

    // Auto-rotate banner
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % bannerImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [bannerImages.length]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  return (
    <>
      <div className="banner-container">
        <div
          className="banner-slider"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {bannerImages.map((image, index) => (
            <div
              key={index}
              className="banner-slide"
              style={{ backgroundImage: `url(${image})` }}
            >
              <div className="banner-overlay">
                <h1>Products</h1>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Category Section - Product Cards with Black Header */}
      <div className="category-section">
        <div className="container">
          <div className="category-grid">
            {categories.map((category, index) => (
              <motion.div 
                key={category.id} 
                className="category-card-wrapper"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Link to={`/productsubcategory/${category.id}`} className="category-card-link">
                  {/* Black Header with Category Name */}
                  <div className="category-header-black">
                    <h3 className="category-header-title">{category.name}</h3>
                  </div>
                  
                  {/* Category Image */}
                  <div className="category-image-container">
                    <div
                      className="category-image"
                      style={{ backgroundImage: `url(${category.image})` }}
                    ></div>
                  </div>
                  
                  {/* Subcategories Section - Black Background with White Text */}
                  {category.subcategory_name && category.subcategory_name.length > 0 && (
                    <div className="subcategories-black">
                      <div className="subcategories-list">
                        {category.subcategory_name.map((subcat, idx) => (
                          <span key={idx} className="subcategory-item">
                            {subcat}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Shop Section */}
      {/* 
      <div className="shop-section">
        <div className="container">
          <h2 className="section-title">SHOP</h2>
          <div className="shop-content">
            <img
              src="assets/img/ecommerce/landingpage/shop.jpg"
              alt="SOLID Osaka Shop"
            />
            <p>
              SOLID Osaka opened on February 21, 2020 in Higashi-Osaka, an area
              lined with many small factories and filled with a warm, human
              atmosphere. We aim to create furniture that will be loved by
              generations. We are committed to using 100% solid wood, and we aim
              to create furniture that can be used for many years to come,
              cherishing memories. With this in mind, SOLID
            </p>
          </div>
        </div>
      </div>

      <div className="contents-section">
        <div className="container">
          <h2 className="section-title">CONTENTS</h2>
          <div className="contents-grid">
            <div className="content-card">
              <img
                src="assets/img/ecommerce/landingpage/content7.jpg"
                alt="Event information"
              />
              <p>Click here for great event information</p>
            </div>
            <div className="content-card">
              <img
                src="assets/img/ecommerce/landingpage/content1.jpg"
                alt="Solid wood table"
              />
              <p>
                The SOLID starting table stands out with its solid wood
                presence.
              </p>
            </div>
            <div className="content-card">
              <img
                src="assets/img/ecommerce/landingpage/content2.jpg"
                alt="Walnut wood"
              />
              <p>A hook chan but cleaning robots can pass through.</p>
              <p>
                The appeal of walnut, one of the world's three most famous
                woods.
              </p>
            </div>
            <div className="content-card">
              <img
                src="assets/img/ecommerce/landingpage/content3.jpg"
                alt="Walnut wood"
              />
              <p>
                The appeal of walnut, one of the world's three most famous
                woods.
              </p>
            </div>
            <div className="content-card">
              <img
                src="assets/img/ecommerce/landingpage/content4.jpg"
                alt="Hook chan"
              />
              <p>A hook chan but cleaning robots can pass through.</p>
              <p>
                The appeal of walnut, one of the world's three most famous
                woods.
              </p>
            </div>
            <div className="content-card">
              <img
                src="assets/img/ecommerce/landingpage/content5.jpg"
                alt="Walnut wood"
              />
              <p>
                The appeal of walnut, one of the world's three most famous
                woods.
              </p>
            </div>
            <div className="content-card">
              <img
                src="assets/img/ecommerce/landingpage/content6.jpg"
                alt="Walnut wood"
              />
              <p>
                The appeal of walnut, one of the world's three most famous
                woods.
              </p>
            </div>
            <div className="content-card">
              <img
                src="assets/img/ecommerce/landingpage/content7.jpg"
                alt="Walnut wood"
              />
              <p>
                The appeal of walnut, one of the world's three most famous
                woods.
              </p>
            </div>
          </div>
        </div>
      </div>
      */}

      <Footer />
    </>
  );
};

export default Productcategory;
